// @flow
import e from "./e";

type valueType = string | number;

export default (conditionValue: valueType) => (fieldValue: valueType) =>
  !e(conditionValue)(fieldValue);
